module.exports = __webpack_public_path__ + "static/img/icon-c-ip.f584dbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-c-ip.png
// module id = rrZB
// module chunks = 21